export default () => ({
  ships: [],
  detailsVisible: false,
  filterVisible: true,
  perPage: 30,
  gridView: true,
});
